import classNames from 'classnames';
import React from 'react';
import './index.less';
var LoadingSpinner = function (_a) {
    var label = _a.label, _b = _a.className, className = _b === void 0 ? null : _b;
    return (React.createElement("div", { className: classNames('spinner', className), "aria-live": "polite", role: "status" },
        React.createElement("div", { className: "spinner__icon" }),
        React.createElement("p", null, label)));
};
export default LoadingSpinner;
